module.exports = __webpack_public_path__ + "static/media/iconfinder_facebook_circle_color_107175.2480ae73.svg";